// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_fU","advertDetailServiceList__header":"c-o_fV","advertDetailServiceList__list":"c-o_fW"};